import styled from 'styled-components'

const BackgroundContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1.5;
    pointer-events: none;
    transform: translateZ(0);
    backface-visibility: hidden;
`

const BackgroundImage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.9;
    transform: translateZ(0);
    backface-visibility: hidden;
    will-change: opacity;

    /* 桌面端背景 */
    @media (min-width: 769px) {
        background-image: url('/assets/images/heroines-background.png');
    }

    /* 移动端背景 */
    @media (max-width: 768px) {
        background-image: url('/assets/images/mobile/heroines-background.png');
        background-position: center top;
    }

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.3),
            rgba(0, 0, 0, 0.5)
        );
        transform: translateZ(0);

        /* 移动端可能需要不同的遮罩效果 */
        @media (max-width: 768px) {
            background: linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0.4),
                rgba(0, 0, 0, 0.6)
            );
        }
    }
`

const HeroinesBackground = () => {
    return (
        <BackgroundContainer>
            <BackgroundImage />
        </BackgroundContainer>
    )
}

export default HeroinesBackground